import { Sport } from '../types';
import { Position } from '../components/DepthChart';

export interface Formation {
  name: string;
  positions: Position[];
}

export interface SportFormations {
  [key: string]: Formation[];
}

// Football offensive formations
export const FOOTBALL_OFFENSIVE_FORMATIONS: Formation[] = [
  {
    name: 'Spread',
    positions: [
      { key: 'QB', name: 'QB', fullName: 'Quarterback', color: '' },
      { key: 'X', name: 'X', fullName: 'X Receiver', color: '' },
      { key: 'Z', name: 'Z', fullName: 'Z Receiver', color: '' },
      { key: 'SL', name: 'SL', fullName: 'Slot Receiver', color: '' },
      { key: 'H', name: 'H', fullName: 'H-Back', color: '' },
      { key: 'RB', name: 'RB', fullName: 'Running Back', color: '' },
      { key: 'LT', name: 'LT', fullName: 'Left Tackle', color: '' },
      { key: 'LG', name: 'LG', fullName: 'Left Guard', color: '' },
      { key: 'C', name: 'C', fullName: 'Center', color: '' },
      { key: 'RG', name: 'RG', fullName: 'Right Guard', color: '' },
      { key: 'RT', name: 'RT', fullName: 'Right Tackle', color: '' }
    ]
  },
  {
    name: 'Pro Style',
    positions: [
      { key: 'QB', name: 'QB', fullName: 'Quarterback', color: '' },
      { key: 'X', name: 'X', fullName: 'X Receiver', color: '' },
      { key: 'Z', name: 'Z', fullName: 'Z Receiver', color: '' },
      { key: 'Y', name: 'Y', fullName: 'Y/Tight End', color: '' },
      { key: 'U', name: 'U', fullName: 'U/Second Tight End', color: '' },
      { key: 'RB', name: 'RB', fullName: 'Running Back', color: '' },
      { key: 'LT', name: 'LT', fullName: 'Left Tackle', color: '' },
      { key: 'LG', name: 'LG', fullName: 'Left Guard', color: '' },
      { key: 'C', name: 'C', fullName: 'Center', color: '' },
      { key: 'RG', name: 'RG', fullName: 'Right Guard', color: '' },
      { key: 'RT', name: 'RT', fullName: 'Right Tackle', color: '' }
    ]
  },
  {
    name: 'I-Form',
    positions: [
      { key: 'QB', name: 'QB', fullName: 'Quarterback', color: '' },
      { key: 'X', name: 'X', fullName: 'X Receiver', color: '' },
      { key: 'Z', name: 'Z', fullName: 'Z Receiver', color: '' },
      { key: 'Y', name: 'Y', fullName: 'Y/Tight End', color: '' },
      { key: 'FB', name: 'FB', fullName: 'Fullback', color: '' },
      { key: 'RB', name: 'RB', fullName: 'Running Back', color: '' },
      { key: 'LT', name: 'LT', fullName: 'Left Tackle', color: '' },
      { key: 'LG', name: 'LG', fullName: 'Left Guard', color: '' },
      { key: 'C', name: 'C', fullName: 'Center', color: '' },
      { key: 'RG', name: 'RG', fullName: 'Right Guard', color: '' },
      { key: 'RT', name: 'RT', fullName: 'Right Tackle', color: '' }
    ]
  },
  {
    name: 'Wing-T',
    positions: [
      { key: 'QB', name: 'QB', fullName: 'Quarterback', color: '' },
      { key: 'WB', name: 'WB', fullName: 'Wingback', color: '' },
      { key: 'TE', name: 'TE', fullName: 'Tight End', color: '' },
      { key: 'SE', name: 'SE', fullName: 'Split End', color: '' },
      { key: 'FB', name: 'FB', fullName: 'Fullback', color: '' },
      { key: 'HB', name: 'HB', fullName: 'Halfback', color: '' },
      { key: 'LT', name: 'LT', fullName: 'Left Tackle', color: '' },
      { key: 'LG', name: 'LG', fullName: 'Left Guard', color: '' },
      { key: 'C', name: 'C', fullName: 'Center', color: '' },
      { key: 'RG', name: 'RG', fullName: 'Right Guard', color: '' },
      { key: 'RT', name: 'RT', fullName: 'Right Tackle', color: '' }
    ]
  },
  {
    name: 'Air Raid',
    positions: [
      { key: 'QB', name: 'QB', fullName: 'Quarterback', color: '' },
      { key: 'X', name: 'X', fullName: 'X Receiver', color: '' },
      { key: 'H', name: 'H', fullName: 'H Receiver', color: '' },
      { key: 'Y', name: 'Y', fullName: 'Y Receiver', color: '' },
      { key: 'Z', name: 'Z', fullName: 'Z Receiver', color: '' },
      { key: 'RB', name: 'RB', fullName: 'Running Back', color: '' },
      { key: 'LT', name: 'LT', fullName: 'Left Tackle', color: '' },
      { key: 'LG', name: 'LG', fullName: 'Left Guard', color: '' },
      { key: 'C', name: 'C', fullName: 'Center', color: '' },
      { key: 'RG', name: 'RG', fullName: 'Right Guard', color: '' },
      { key: 'RT', name: 'RT', fullName: 'Right Tackle', color: '' }
    ]
  },
  {
    name: 'Singleback',
    positions: [
      { key: 'QB', name: 'QB', fullName: 'Quarterback', color: '' },
      { key: 'X', name: 'X', fullName: 'X Receiver', color: '' },
      { key: 'Z', name: 'Z', fullName: 'Z Receiver', color: '' },
      { key: 'Y', name: 'Y', fullName: 'Tight End', color: '' },
      { key: 'RB', name: 'RB', fullName: 'Running Back', color: '' },
      { key: 'LT', name: 'LT', fullName: 'Left Tackle', color: '' },
      { key: 'LG', name: 'LG', fullName: 'Left Guard', color: '' },
      { key: 'C', name: 'C', fullName: 'Center', color: '' },
      { key: 'RG', name: 'RG', fullName: 'Right Guard', color: '' },
      { key: 'RT', name: 'RT', fullName: 'Right Tackle', color: '' },
      { key: 'SL', name: 'SL', fullName: 'Slot Receiver', color: '' }
    ]
  },
  {
    name: 'Trips',
    positions: [
      { key: 'QB', name: 'QB', fullName: 'Quarterback', color: '' },
      { key: 'X', name: 'X', fullName: 'X Receiver', color: '' },
      { key: 'Y', name: 'Y', fullName: 'Y Receiver (Slot)', color: '' },
      { key: 'Z', name: 'Z', fullName: 'Z Receiver', color: '' },
      { key: 'RB', name: 'RB', fullName: 'Running Back', color: '' },
      { key: 'LT', name: 'LT', fullName: 'Left Tackle', color: '' },
      { key: 'LG', name: 'LG', fullName: 'Left Guard', color: '' },
      { key: 'C', name: 'C', fullName: 'Center', color: '' },
      { key: 'RG', name: 'RG', fullName: 'Right Guard', color: '' },
      { key: 'RT', name: 'RT', fullName: 'Right Tackle', color: '' },
      { key: 'TE', name: 'TE', fullName: 'Tight End', color: '' }
    ]
  },
  {
    name: 'Empty',
    positions: [
      { key: 'QB', name: 'QB', fullName: 'Quarterback', color: '' },
      { key: 'X', name: 'X', fullName: 'X Receiver', color: '' },
      { key: 'Z', name: 'Z', fullName: 'Z Receiver', color: '' },
      { key: 'H', name: 'H', fullName: 'H Receiver (Slot)', color: '' },
      { key: 'Y', name: 'Y', fullName: 'Y Receiver (Slot)', color: '' },
      { key: 'W', name: 'W', fullName: 'W Receiver', color: '' },
      { key: 'LT', name: 'LT', fullName: 'Left Tackle', color: '' },
      { key: 'LG', name: 'LG', fullName: 'Left Guard', color: '' },
      { key: 'C', name: 'C', fullName: 'Center', color: '' },
      { key: 'RG', name: 'RG', fullName: 'Right Guard', color: '' },
      { key: 'RT', name: 'RT', fullName: 'Right Tackle', color: '' }
    ]
  },
  {
    name: 'Pistol',
    positions: [
      { key: 'QB', name: 'QB', fullName: 'Quarterback', color: '' },
      { key: 'RB', name: 'RB', fullName: 'Running Back', color: '' },
      { key: 'X', name: 'X', fullName: 'X Receiver', color: '' },
      { key: 'Z', name: 'Z', fullName: 'Z Receiver', color: '' },
      { key: 'Y', name: 'Y', fullName: 'Tight End', color: '' },
      { key: 'SL', name: 'SL', fullName: 'Slot Receiver', color: '' },
      { key: 'LT', name: 'LT', fullName: 'Left Tackle', color: '' },
      { key: 'LG', name: 'LG', fullName: 'Left Guard', color: '' },
      { key: 'C', name: 'C', fullName: 'Center', color: '' },
      { key: 'RG', name: 'RG', fullName: 'Right Guard', color: '' },
      { key: 'RT', name: 'RT', fullName: 'Right Tackle', color: '' }
    ]
  },
  {
    name: 'T-Formation',
    positions: [
      { key: 'QB', name: 'QB', fullName: 'Quarterback', color: '' },
      { key: 'FB', name: 'FB', fullName: 'Fullback', color: '' },
      { key: 'HB1', name: 'HB1', fullName: 'Halfback 1', color: '' },
      { key: 'HB2', name: 'HB2', fullName: 'Halfback 2', color: '' },
      { key: 'SE', name: 'SE', fullName: 'Split End', color: '' },
      { key: 'TE', name: 'TE', fullName: 'Tight End', color: '' },
      { key: 'LT', name: 'LT', fullName: 'Left Tackle', color: '' },
      { key: 'LG', name: 'LG', fullName: 'Left Guard', color: '' },
      { key: 'C', name: 'C', fullName: 'Center', color: '' },
      { key: 'RG', name: 'RG', fullName: 'Right Guard', color: '' },
      { key: 'RT', name: 'RT', fullName: 'Right Tackle', color: '' }
    ]
  },
  {
    name: 'Beast',
    positions: [
      { key: 'QB', name: 'QB', fullName: 'Quarterback (usually under center)', color: '' },
      { key: 'FB', name: 'FB', fullName: 'Fullback (direct snap or lead blocker)', color: '' },
      { key: 'HB1', name: 'HB1', fullName: 'Halfback 1 (tight wing)', color: '' },
      { key: 'HB2', name: 'HB2', fullName: 'Halfback 2 (tight wing)', color: '' },
      { key: 'TE', name: 'TE', fullName: 'Tight End', color: '' },
      { key: 'SE', name: 'SE', fullName: 'Split End', color: '' },
      { key: 'LT', name: 'LT', fullName: 'Left Tackle', color: '' },
      { key: 'LG', name: 'LG', fullName: 'Left Guard', color: '' },
      { key: 'C', name: 'C', fullName: 'Center', color: '' },
      { key: 'RG', name: 'RG', fullName: 'Right Guard', color: '' },
      { key: 'RT', name: 'RT', fullName: 'Right Tackle', color: '' }
    ]
  },
  {
    name: 'Wishbone',
    positions: [
      { key: 'QB', name: 'QB', fullName: 'Quarterback', color: '' },
      { key: 'FB', name: 'FB', fullName: 'Fullback (directly behind QB)', color: '' },
      { key: 'HB1', name: 'HB1', fullName: 'Halfback 1 (left)', color: '' },
      { key: 'HB2', name: 'HB2', fullName: 'Halfback 2 (right)', color: '' },
      { key: 'TE', name: 'TE', fullName: 'Tight End', color: '' },
      { key: 'SE', name: 'SE', fullName: 'Split End', color: '' },
      { key: 'LT', name: 'LT', fullName: 'Left Tackle', color: '' },
      { key: 'LG', name: 'LG', fullName: 'Left Guard', color: '' },
      { key: 'C', name: 'C', fullName: 'Center', color: '' },
      { key: 'RG', name: 'RG', fullName: 'Right Guard', color: '' },
      { key: 'RT', name: 'RT', fullName: 'Right Tackle', color: '' }
    ]
  },
  {
    name: 'Gun-T',
    positions: [
      { key: 'QB', name: 'QB', fullName: 'Quarterback (shotgun)', color: '' },
      { key: 'FB', name: 'FB', fullName: 'Fullback (offset or behind QB)', color: '' },
      { key: 'WB', name: 'WB', fullName: 'Wingback', color: '' },
      { key: 'HB', name: 'HB', fullName: 'Halfback', color: '' },
      { key: 'TE', name: 'TE', fullName: 'Tight End', color: '' },
      { key: 'SE', name: 'SE', fullName: 'Split End', color: '' },
      { key: 'LT', name: 'LT', fullName: 'Left Tackle', color: '' },
      { key: 'LG', name: 'LG', fullName: 'Left Guard', color: '' },
      { key: 'C', name: 'C', fullName: 'Center', color: '' },
      { key: 'RG', name: 'RG', fullName: 'Right Guard', color: '' },
      { key: 'RT', name: 'RT', fullName: 'Right Tackle', color: '' }
    ]
  },
  {
    name: 'Goaline',
    positions: [
      { key: 'QB', name: 'QB', fullName: 'Quarterback (under center)', color: '' },
      { key: 'FB', name: 'FB', fullName: 'Fullback', color: '' },
      { key: 'RB', name: 'RB', fullName: 'Running Back', color: '' },
      { key: 'TE1', name: 'TE1', fullName: 'Tight End 1 (left)', color: '' },
      { key: 'TE2', name: 'TE2', fullName: 'Tight End 2 (right)', color: '' },
      { key: 'TE3', name: 'TE3', fullName: 'Extra Tight End (inline)', color: '' },
      { key: 'LT', name: 'LT', fullName: 'Left Tackle', color: '' },
      { key: 'LG', name: 'LG', fullName: 'Left Guard', color: '' },
      { key: 'C', name: 'C', fullName: 'Center', color: '' },
      { key: 'RG', name: 'RG', fullName: 'Right Guard', color: '' },
      { key: 'RT', name: 'RT', fullName: 'Right Tackle', color: '' }
    ]
  }    
];

// Football defensive formations
export const FOOTBALL_DEFENSIVE_FORMATIONS: Formation[] = [
  {
    name: '4-3',
    positions: [
      { key: 'LDE', name: 'LDE', fullName: 'Left Defensive End', color: '' },
      { key: 'LDT', name: 'LDT', fullName: 'Left Defensive Tackle', color: '' },
      { key: 'RDT', name: 'RDT', fullName: 'Right Defensive Tackle', color: '' },
      { key: 'RDE', name: 'RDE', fullName: 'Right Defensive End', color: '' },
      { key: 'WLB', name: 'WLB', fullName: 'Weakside Linebacker', color: '' },
      { key: 'MLB', name: 'MLB', fullName: 'Middle Linebacker', color: '' },
      { key: 'SLB', name: 'SLB', fullName: 'Strongside Linebacker', color: '' },
      { key: 'LCB', name: 'LCB', fullName: 'Left Cornerback', color: '' },
      { key: 'RCB', name: 'RCB', fullName: 'Right Cornerback', color: '' },
      { key: 'FS', name: 'FS', fullName: 'Free Safety', color: '' },
      { key: 'SS', name: 'SS', fullName: 'Strong Safety', color: '' }
    ]
  },
  {
    name: '3-4',
    positions: [
      { key: 'LDE', name: 'LDE', fullName: 'Left Defensive End', color: '' },
      { key: 'NT', name: 'NT', fullName: 'Nose Tackle', color: '' },
      { key: 'RDE', name: 'RDE', fullName: 'Right Defensive End', color: '' },
      { key: 'LOLB', name: 'LOLB', fullName: 'Left Outside Linebacker', color: '' },
      { key: 'LILB', name: 'LILB', fullName: 'Left Inside Linebacker', color: '' },
      { key: 'RILB', name: 'RILB', fullName: 'Right Inside Linebacker', color: '' },
      { key: 'ROLB', name: 'ROLB', fullName: 'Right Outside Linebacker', color: '' },
      { key: 'LCB', name: 'LCB', fullName: 'Left Cornerback', color: '' },
      { key: 'RCB', name: 'RCB', fullName: 'Right Cornerback', color: '' },
      { key: 'FS', name: 'FS', fullName: 'Free Safety', color: '' },
      { key: 'SS', name: 'SS', fullName: 'Strong Safety', color: '' }
    ]
  },
  {
    name: 'Nickel',
    positions: [
      { key: 'LDE', name: 'LDE', fullName: 'Left Defensive End', color: '' },
      { key: 'LDT', name: 'LDT', fullName: 'Left Defensive Tackle', color: '' },
      { key: 'RDT', name: 'RDT', fullName: 'Right Defensive Tackle', color: '' },
      { key: 'RDE', name: 'RDE', fullName: 'Right Defensive End', color: '' },
      { key: 'WLB', name: 'WLB', fullName: 'Weakside Linebacker', color: '' },
      { key: 'MLB', name: 'MLB', fullName: 'Middle Linebacker', color: '' },
      { key: 'LCB', name: 'LCB', fullName: 'Left Cornerback', color: '' },
      { key: 'RCB', name: 'RCB', fullName: 'Right Cornerback', color: '' },
      { key: 'NB', name: 'NB', fullName: 'Nickelback', color: '' },
      { key: 'FS', name: 'FS', fullName: 'Free Safety', color: '' },
      { key: 'SS', name: 'SS', fullName: 'Strong Safety', color: '' }
    ]
  },
  {
    name: '4-6 Bear',
    positions: [
      { key: 'LDE', name: 'LDE', fullName: 'Left Defensive End', color: '' },
      { key: 'LDT', name: 'LDT', fullName: 'Left Defensive Tackle', color: '' },
      { key: 'RDT', name: 'RDT', fullName: 'Right Defensive Tackle', color: '' },
      { key: 'RDE', name: 'RDE', fullName: 'Right Defensive End', color: '' },
      { key: 'SLB', name: 'SLB', fullName: 'Strongside Linebacker', color: '' },
      { key: 'WLB', name: 'WLB', fullName: 'Weakside Linebacker', color: '' },
      { key: 'ILB1', name: 'ILB1', fullName: 'Inside Linebacker 1', color: '' },
      { key: 'ILB2', name: 'ILB2', fullName: 'Inside Linebacker 2', color: '' },
      { key: 'LCB', name: 'LCB', fullName: 'Left Cornerback', color: '' },
      { key: 'RCB', name: 'RCB', fullName: 'Right Cornerback', color: '' },
      { key: 'SS', name: 'SS', fullName: 'Strong Safety (in box)', color: '' }
    ]
  },
  {
    name: '4-4 Stack',
    positions: [
      { key: 'LDE', name: 'LDE', fullName: 'Left Defensive End', color: '' },
      { key: 'LDT', name: 'LDT', fullName: 'Left Defensive Tackle', color: '' },
      { key: 'RDT', name: 'RDT', fullName: 'Right Defensive Tackle', color: '' },
      { key: 'RDE', name: 'RDE', fullName: 'Right Defensive End', color: '' },
      { key: 'OLB1', name: 'OLB1', fullName: 'Outside Linebacker 1', color: '' },
      { key: 'OLB2', name: 'OLB2', fullName: 'Outside Linebacker 2', color: '' },
      { key: 'ILB1', name: 'ILB1', fullName: 'Inside Linebacker 1', color: '' },
      { key: 'ILB2', name: 'ILB2', fullName: 'Inside Linebacker 2', color: '' },
      { key: 'LCB', name: 'LCB', fullName: 'Left Cornerback', color: '' },
      { key: 'RCB', name: 'RCB', fullName: 'Right Cornerback', color: '' },
      { key: 'FS', name: 'FS', fullName: 'Free Safety', color: '' }
    ]
  },
  {
    name: '4-2-5',
    positions: [
      { key: 'LDE', name: 'LDE', fullName: 'Left Defensive End', color: '' },
      { key: 'LDT', name: 'LDT', fullName: 'Left Defensive Tackle', color: '' },
      { key: 'RDT', name: 'RDT', fullName: 'Right Defensive Tackle', color: '' },
      { key: 'RDE', name: 'RDE', fullName: 'Right Defensive End', color: '' },
      { key: 'WLB', name: 'WLB', fullName: 'Weakside Linebacker', color: '' },
      { key: 'MLB', name: 'MLB', fullName: 'Middle Linebacker', color: '' },
      { key: 'LCB', name: 'LCB', fullName: 'Left Cornerback', color: '' },
      { key: 'RCB', name: 'RCB', fullName: 'Right Cornerback', color: '' },
      { key: 'NB', name: 'NB', fullName: 'Nickelback', color: '' },
      { key: 'FS', name: 'FS', fullName: 'Free Safety', color: '' },
      { key: 'SS', name: 'SS', fullName: 'Strong Safety', color: '' }
    ]
  },
  {
    name: '3-3-5',
    positions: [
      { key: 'LDE', name: 'LDE', fullName: 'Left Defensive End', color: '' },
      { key: 'NT', name: 'NT', fullName: 'Nose Tackle', color: '' },
      { key: 'RDE', name: 'RDE', fullName: 'Right Defensive End', color: '' },
      { key: 'SLB', name: 'SLB', fullName: 'Strongside Linebacker', color: '' },
      { key: 'MLB', name: 'MLB', fullName: 'Middle Linebacker', color: '' },
      { key: 'WLB', name: 'WLB', fullName: 'Weakside Linebacker', color: '' },
      { key: 'LCB', name: 'LCB', fullName: 'Left Cornerback', color: '' },
      { key: 'RCB', name: 'RCB', fullName: 'Right Cornerback', color: '' },
      { key: 'NB', name: 'NB', fullName: 'Nickelback', color: '' },
      { key: 'FS', name: 'FS', fullName: 'Free Safety', color: '' },
      { key: 'SS', name: 'SS', fullName: 'Strong Safety', color: '' }
    ]
  },
  {
    name: '5-3',
    positions: [
      { key: 'LDE', name: 'LDE', fullName: 'Left Defensive End', color: '' },
      { key: 'LDT', name: 'LDT', fullName: 'Left Defensive Tackle', color: '' },
      { key: 'RDT', name: 'RDT', fullName: 'Right Defensive Tackle', color: '' },
      { key: 'RDE', name: 'RDE', fullName: 'Right Defensive End', color: '' },
      { key: 'NT', name: 'NT', fullName: 'Nose Tackle', color: '' },
      { key: 'SLB', name: 'SLB', fullName: 'Strongside Linebacker', color: '' },
      { key: 'MLB', name: 'MLB', fullName: 'Middle Linebacker', color: '' },
      { key: 'WLB', name: 'WLB', fullName: 'Weakside Linebacker', color: '' },
      { key: 'LCB', name: 'LCB', fullName: 'Left Cornerback', color: '' },
      { key: 'RCB', name: 'RCB', fullName: 'Right Cornerback', color: '' },
      { key: 'FS', name: 'FS', fullName: 'Free Safety', color: '' }
    ]
  },
  {
    name: '6-2',
    positions: [
      { key: 'LDE', name: 'LDE', fullName: 'Left Defensive End', color: '' },
      { key: 'LDT', name: 'LDT', fullName: 'Left Defensive Tackle', color: '' },
      { key: 'RDT', name: 'RDT', fullName: 'Right Defensive Tackle', color: '' },
      { key: 'RDE', name: 'RDE', fullName: 'Right Defensive End', color: '' },
      { key: 'LEDGE', name: 'LEDGE', fullName: 'Left EDGE', color: '' },
      { key: 'REDGE', name: 'REDGE', fullName: 'Right EDGE', color: '' },
      { key: 'MLB1', name: 'MLB1', fullName: 'Middle Linebacker 1', color: '' },
      { key: 'MLB2', name: 'MLB2', fullName: 'Middle Linebacker 2', color: '' },
      { key: 'LCB', name: 'LCB', fullName: 'Left Cornerback', color: '' },
      { key: 'RCB', name: 'RCB', fullName: 'Right Cornerback', color: '' },
      { key: 'FS', name: 'FS', fullName: 'Free Safety', color: '' }
    ]
  },
  {
    name: 'Goaline',
    positions: [
      { key: 'LDE', name: 'LDE', fullName: 'Left Defensive End', color: '' },
      { key: 'LDT', name: 'LDT', fullName: 'Left Defensive Tackle', color: '' },
      { key: 'RDT', name: 'RDT', fullName: 'Right Defensive Tackle', color: '' },
      { key: 'RDE', name: 'RDE', fullName: 'Right Defensive End', color: '' },
      { key: 'RE', name: 'RE', fullName: 'Right End', color: '' },
      { key: 'SLB', name: 'SLB', fullName: 'Strongside Linebacker', color: '' },
      { key: 'MLB', name: 'MLB', fullName: 'Middle Linebacker', color: '' },
      { key: 'WLB', name: 'WLB', fullName: 'Weakside Linebacker', color: '' },
      { key: 'LCB', name: 'LCB', fullName: 'Left Cornerback', color: '' },
      { key: 'RCB', name: 'RCB', fullName: 'Right Cornerback', color: '' },
      { key: 'SS', name: 'SS', fullName: 'Strong Safety (in the box)', color: '' }
    ]
  }    
];

export const FLAG_FOOTBALL_OFFENSIVE_FORMATIONS: Formation[] = [
  {
    name: 'Trips',
    positions: [
      { key: 'QB', name: 'QB', fullName: 'Quarterback', color: '' },
      { key: 'C', name: 'C', fullName: 'Center', color: '' },
      { key: 'WR1', name: 'WR1', fullName: 'Wide Receiver 1 (Trips Side)', color: '' },
      { key: 'WR2', name: 'WR2', fullName: 'Wide Receiver 2 (Trips Side)', color: '' },
      { key: 'WR3', name: 'WR3', fullName: 'Wide Receiver 3 (Opposite Side)', color: '' }
    ]
  },
  {
    name: 'Twins',
    positions: [
      { key: 'QB', name: 'QB', fullName: 'Quarterback', color: '' },
      { key: 'C', name: 'C', fullName: 'Center', color: '' },
      { key: 'WRL1', name: 'WRL1', fullName: 'Wide Receiver Left 1', color: '' },
      { key: 'WRR1', name: 'WRR1', fullName: 'Wide Receiver Right 1', color: '' },
      { key: 'RB', name: 'RB', fullName: 'Running Back / Slot Receiver', color: '' }
    ]
  },
  {
    name: 'Stack',
    positions: [
      { key: 'QB', name: 'QB', fullName: 'Quarterback', color: '' },
      { key: 'C', name: 'C', fullName: 'Center', color: '' },
      { key: 'WR1', name: 'WR1', fullName: 'Wide Receiver 1 (Front of Stack)', color: '' },
      { key: 'WR2', name: 'WR2', fullName: 'Wide Receiver 2 (Back of Stack)', color: '' },
      { key: 'WR3', name: 'WR3', fullName: 'Wide Receiver (Opposite Side)', color: '' }
    ]
  },
  {
    name: 'Bunch',
    positions: [
      { key: 'QB', name: 'QB', fullName: 'Quarterback', color: '' },
      { key: 'C', name: 'C', fullName: 'Center', color: '' },
      { key: 'WR1', name: 'WR1', fullName: 'Wide Receiver 1 (Point of Bunch)', color: '' },
      { key: 'WR2', name: 'WR2', fullName: 'Wide Receiver 2 (Inside)', color: '' },
      { key: 'WR3', name: 'WR3', fullName: 'Wide Receiver 3 (Outside)', color: '' }
    ]
  },
  {
    name: 'Spread',
    positions: [
      { key: 'QB', name: 'QB', fullName: 'Quarterback', color: '' },
      { key: 'C', name: 'C', fullName: 'Center', color: '' },
      { key: 'WRL', name: 'WRL', fullName: 'Wide Receiver Left', color: '' },
      { key: 'WRR', name: 'WRR', fullName: 'Wide Receiver Right', color: '' },
      { key: 'SL', name: 'SL', fullName: 'Slot Receiver', color: '' }
    ]
  }
];

// Soccer formations
export const SOCCER_FORMATIONS: Formation[] = [
  {
    name: '4-4-2',
    positions: [
      { key: 'GK', name: 'GK', fullName: 'Goalkeeper', color: '' },
      { key: 'LB', name: 'LB', fullName: 'Left Back', color: '' },
      { key: 'CB1', name: 'CB1', fullName: 'Center Back 1', color: '' },
      { key: 'CB2', name: 'CB2', fullName: 'Center Back 2', color: '' },
      { key: 'RB', name: 'RB', fullName: 'Right Back', color: '' },
      { key: 'LM', name: 'LM', fullName: 'Left Midfielder', color: '' },
      { key: 'CM1', name: 'CM1', fullName: 'Center Midfielder 1', color: '' },
      { key: 'CM2', name: 'CM2', fullName: 'Center Midfielder 2', color: '' },
      { key: 'RM', name: 'RM', fullName: 'Right Midfielder', color: '' },
      { key: 'ST1', name: 'ST1', fullName: 'Striker 1', color: '' },
      { key: 'ST2', name: 'ST2', fullName: 'Striker 2', color: '' }
    ]
  },
  {
    name: '4-3-3',
    positions: [
      { key: 'GK', name: 'GK', fullName: 'Goalkeeper', color: '' },
      { key: 'LB', name: 'LB', fullName: 'Left Back', color: '' },
      { key: 'CB1', name: 'CB1', fullName: 'Center Back 1', color: '' },
      { key: 'CB2', name: 'CB2', fullName: 'Center Back 2', color: '' },
      { key: 'RB', name: 'RB', fullName: 'Right Back', color: '' },
      { key: 'CDM', name: 'CDM', fullName: 'Central Defensive Midfielder', color: '' },
      { key: 'CM1', name: 'CM1', fullName: 'Center Midfielder 1', color: '' },
      { key: 'CM2', name: 'CM2', fullName: 'Center Midfielder 2', color: '' },
      { key: 'LW', name: 'LW', fullName: 'Left Wing', color: '' },
      { key: 'ST', name: 'ST', fullName: 'Striker', color: '' },
      { key: 'RW', name: 'RW', fullName: 'Right Wing', color: '' }
    ]
  },
  {
    name: '3-5-2',
    positions: [
      { key: 'GK', name: 'GK', fullName: 'Goalkeeper', color: '' },
      { key: 'CB1', name: 'CB1', fullName: 'Center Back 1', color: '' },
      { key: 'CB2', name: 'CB2', fullName: 'Center Back 2', color: '' },
      { key: 'CB3', name: 'CB3', fullName: 'Center Back 3', color: '' },
      { key: 'LWB', name: 'LWB', fullName: 'Left Wing Back', color: '' },
      { key: 'CDM', name: 'CDM', fullName: 'Central Defensive Midfielder', color: '' },
      { key: 'CM1', name: 'CM1', fullName: 'Center Midfielder 1', color: '' },
      { key: 'CM2', name: 'CM2', fullName: 'Center Midfielder 2', color: '' },
      { key: 'RWB', name: 'RWB', fullName: 'Right Wing Back', color: '' },
      { key: 'ST1', name: 'ST1', fullName: 'Striker 1', color: '' },
      { key: 'ST2', name: 'ST2', fullName: 'Striker 2', color: '' }
    ]
  }
];

// Football special teams formations
export const FOOTBALL_SPECIAL_TEAMS_FORMATIONS: Formation[] = [
  {
    name: 'Kickoff',
    positions: [
      { key: 'K', name: 'K', fullName: 'Kicker', color: '' },
      { key: 'L1', name: 'L1', fullName: 'Left 1', color: '' },
      { key: 'L2', name: 'L2', fullName: 'Left 2', color: '' },
      { key: 'L3', name: 'L3', fullName: 'Left 3', color: '' },
      { key: 'L4', name: 'L4', fullName: 'Left 4', color: '' },
      { key: 'L5', name: 'L5', fullName: 'Left 5', color: '' },
      { key: 'R1', name: 'R1', fullName: 'Right 1', color: '' },
      { key: 'R2', name: 'R2', fullName: 'Right 2', color: '' },
      { key: 'R3', name: 'R3', fullName: 'Right 3', color: '' },
      { key: 'R4', name: 'R4', fullName: 'Right 4', color: '' },
      { key: 'R5', name: 'R5', fullName: 'Right 5', color: '' }
    ]
  },
  {
    name: 'Kick Return',
    positions: [
      { key: 'KR1', name: 'KR1', fullName: 'Primary Returner', color: '' },
      { key: 'KR2', name: 'KR2', fullName: 'Secondary Returner', color: '' },
      { key: 'FB', name: 'FB', fullName: 'Fullback', color: '' },
      { key: 'F1', name: 'F1', fullName: 'Front 1', color: '' },
      { key: 'F2', name: 'F2', fullName: 'Front 2', color: '' },
      { key: 'F3', name: 'F3', fullName: 'Front 3', color: '' },
      { key: 'F4', name: 'F4', fullName: 'Front 4', color: '' },
      { key: 'M1', name: 'M1', fullName: 'Middle 1', color: '' },
      { key: 'M2', name: 'M2', fullName: 'Middle 2', color: '' },
      { key: 'M3', name: 'M3', fullName: 'Middle 3', color: '' },
      { key: 'M4', name: 'M4', fullName: 'Middle 4', color: '' }
    ]
  },
  {
    name: 'Punt',
    positions: [
      { key: 'P', name: 'P', fullName: 'Punter', color: '' },
      { key: 'LS', name: 'LS', fullName: 'Long Snapper', color: '' },
      { key: 'PP', name: 'PP', fullName: 'Personal Protector', color: '' },
      { key: 'LG', name: 'LG', fullName: 'Left Guard', color: '' },
      { key: 'RG', name: 'RG', fullName: 'Right Guard', color: '' },
      { key: 'LW', name: 'LW', fullName: 'Left Wing', color: '' },
      { key: 'RW', name: 'RW', fullName: 'Right Wing', color: '' },
      { key: 'LT', name: 'LT', fullName: 'Left Tackle', color: '' },
      { key: 'RT', name: 'RT', fullName: 'Right Tackle', color: '' },
      { key: 'GLt', name: 'GLt', fullName: 'Gunner Left', color: '' },
      { key: 'GRt', name: 'GRt', fullName: 'Gunner Right', color: '' }
    ]
  },
  {
    name: 'Punt Return',
    positions: [
      { key: 'PR', name: 'PR', fullName: 'Punt Returner', color: '' },
      { key: 'LOLB', name: 'LOLB', fullName: 'Left Outside LB', color: '' },
      { key: 'LILB', name: 'LILB', fullName: 'Left Inside LB', color: '' },
      { key: 'MLB', name: 'MLB', fullName: 'Middle LB', color: '' },
      { key: 'RILB', name: 'RILB', fullName: 'Right Inside LB', color: '' },
      { key: 'ROLB', name: 'ROLB', fullName: 'Right Outside LB', color: '' },
      { key: 'LCB', name: 'LCB', fullName: 'Left Cornerback', color: '' },
      { key: 'RCB', name: 'RCB', fullName: 'Right Cornerback', color: '' },
      { key: 'FS', name: 'FS', fullName: 'Free Safety', color: '' },
      { key: 'LS', name: 'LS', fullName: 'Left Safety', color: '' },
      { key: 'RS', name: 'RS', fullName: 'Right Safety', color: '' }
    ]
  },
  {
    name: 'Field Goal',
    positions: [
      { key: 'K', name: 'K', fullName: 'Kicker', color: '' },
      { key: 'H', name: 'H', fullName: 'Holder', color: '' },
      { key: 'LS', name: 'LS', fullName: 'Long Snapper', color: '' },
      { key: 'LG', name: 'LG', fullName: 'Left Guard', color: '' },
      { key: 'LT', name: 'LT', fullName: 'Left Tackle', color: '' },
      { key: 'LE', name: 'LE', fullName: 'Left End', color: '' },
      { key: 'RG', name: 'RG', fullName: 'Right Guard', color: '' },
      { key: 'RT', name: 'RT', fullName: 'Right Tackle', color: '' },
      { key: 'RE', name: 'RE', fullName: 'Right End', color: '' },
      { key: 'WB1', name: 'WB1', fullName: 'Wing Back 1', color: '' },
      { key: 'WB2', name: 'WB2', fullName: 'Wing Back 2', color: '' }
    ]
  }
];